import { Link } from 'react-router-dom'

export function BtnAccent({ to, children, className = '' }) {
  return (
    <Link
      to={to}
      className={`inline-block bg-ds-red text-white font-display font-bold text-[14px] tracking-btn uppercase px-7 py-[14px] rounded-sharp no-underline hover:bg-ds-red-hover hover:scale-[1.015] transition-all duration-150 ${className}`}
    >
      {children}
    </Link>
  )
}
